/** Material Form Field Appearance options for inputAppearance dropdown in Domain Settings form */
export const MAT_FORM_APPEARANCE = {
  FILL: "fill",
  OUTLINE: "outline"
};

/** Floating label options for inputFloatingLabel dropdown in Domain Settings form */
export const LABEL_FLOAT = {
  ALWAYS: "always",
  NEVER: "never",
  AUTO: "auto"
};

/** Horizontal position options for notifyHorizontalPosition dropdown in Domain Settings form */
export const HORIZONTAL_POSITIONS = {
  START: "start",
  CENTER: "center",
  END: "end",
  LEFT: "left",
  RIGHT: "right"
};

/** Vertical position options for notifyVerticalPosition dropdown in Domain Settings form */
export const VERTICAL_POSITIONS = {
  TOP: "top",
  BOTTOM: "bottom"
};

/** Tooltip position options for toolTipPosition dropdown in Domain Settings form */
export const TOOLTIP_POSITIONS = {
  LEFT: "left",
  RIGHT: "right",
  ABOVE: "above",
  BELOW: "below",
  BEFORE: "before",
  AFTER: "after"
};

/**
 * Input field settings interface
 */
export interface InputSettings {
  inputAppearance: string;
  inputHideRequiredMarker: boolean;
  inputFloatingLabel: string;
  inputDebounce: number;
  inputFontSize: number;
}

/** Notifications settings interface */
export interface NotificationSettings {
  notifyDefaultMessage: string;
  notifyDuration: number;
  notifyHorizontalPosition: string;
  notifyVerticalPosition: string;
}

/** Tooltips settings interface */
export interface TooltipSettings {
  toolTipShowDelay: number;
  toolTipHideDelay: number;
  toolTipHideDelayMobile: number;
  toolTipPosition: string;
}

/** Context menu settings interface */
export interface ContextMenuSettings {
  contextShowOnLeftClick: boolean;
  contextAutoSelectAction: boolean;
}
